// ////////////////////////////スマホ/タブレット判別
var _ua = (function (u) {
  return {
    Tablet:
      (u.indexOf('windows') != -1 && u.indexOf('touch') != -1) ||
      u.indexOf('ipad') != -1 ||
      (u.indexOf('android') != -1 && u.indexOf('mobile') == -1) ||
      (u.indexOf('firefox') != -1 && u.indexOf('tablet') != -1) ||
      u.indexOf('kindle') != -1 ||
      u.indexOf('silk') != -1 ||
      u.indexOf('playbook') != -1,
    Mobile:
      (u.indexOf('windows') != -1 && u.indexOf('phone') != -1) ||
      u.indexOf('iphone') != -1 ||
      u.indexOf('ipod') != -1 ||
      (u.indexOf('android') != -1 && u.indexOf('mobile') != -1) ||
      (u.indexOf('firefox') != -1 && u.indexOf('mobile') != -1) ||
      u.indexOf('blackberry') != -1,
  };
})(window.navigator.userAgent.toLowerCase());
// if(_ua.Mobile){}

var osVer;
osVer = 'Android';

var ua = navigator.userAgent.toLowerCase();
var iPadFlag = false;
if (/android|ipod|ipad|iphone|macintosh/.test(ua) && 'ontouchend' in document) {
  iPadFlag = true;
}
// if (navigator.userAgent.indexOf(osVer)>0){
// }

var breakNum = 768;
var tabletNum = 1024;
// ////////////////////////////////////init
$(function () {
  setScroll();
  if ($('#wrapper').hasClass('home')) {
  }
  // ///////////
  if (!_ua.Mobile && !_ua.Tablet) {
    $('#wrapper').addClass('desktop');
    if (!$('#wrapper').hasClass('about')) {
      $('html, body').prop({
        scrollTop: 0,
      });
      if (ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1 && ua.indexOf('edge') === -1) {
        // ここにSafari用の記述
      } else {
      }
    }
  }
  // ///////////
});

$(window).on('load', function () {
  // heightLineGroup()
  judgeWinSize();
  // setHeader();
  // setGnav();
  // setAcc();
  setLoaded();
  setSpan();
  setGsap();
  setScrollTop();
  // setWay();
  // setGsap();
  // setSpan();
  setMainMenu();
  setScroll();
  setAccMenu();
  setHeader();
  setAcc();
  // setHeader()
  if ($('#wrapper').hasClass('home')) {
    setRellax();
    topVis();
  } else if ($('#wrapper').hasClass('about')) {
    setPhilosophy();
    setRellax();
    setProfile();
    startScroll();
  } else if ($('#wrapper').hasClass('scheme')) {
    setStickyAcc();
    // switchMovie();
  } else if ($('#wrapper').hasClass('contact')) {
    setForm();
  } else if ($('#wrapper').hasClass('philosophy')) {
    startScroll();
  } else if ($('#wrapper').hasClass('project')) {
    setProject();
  } else if ($('#wrapper').hasClass('privacy-policy')) {
    startScroll();
  }
  if (!_ua.Mobile) {
  }
  if (!_ua.Mobile && !_ua.Tablet) {
  }
  // if (
  //   $('#wrapper').hasClass('recruit') ||
  //   $('#wrapper').hasClass('service') ||
  //   $('#wrapper').hasClass('works')
  // ) {
  //   setTimeout(function () {
  //     setSlider();
  //   }, 100);
  // } else if ($('#wrapper').hasClass('entry')) {
  //   setBirth();
  //   setForm();
  // } else if ($('#wrapper').hasClass('contact')) {
  //   setForm();
  // } else if ($('#wrapper').hasClass('home') || $('#wrapper').hasClass('works')) {
  //   startScroll();
  // }
  // if ($('#wrapper').hasClass('taxonomy-category-works')) {
  //   worksUnq();
  // }
  // if ($('#wrapper').hasClass('fanclub')) {
  //   setScrollHint();
  // }
});

//動画のスマホ切り替え
function switchMovie() {
  // 切り替える対象にclass属性。
  var $elem = $('.switch');

  // 切り替えの対象のsrc属性の末尾の文字列。
  var sp = '_sp.';
  var pc = '_pc.';

  // 画像を切り替えるウィンドウサイズ。
  var replaceWidth = 768;

  function imageSwitch() {
    // ウィンドウサイズを取得する。
    var windowWidth = parseInt($(window).width());

    // ページ内にあるすべての`.switch`に適応される。
    $elem.each(function () {
      var $this = $(this);
      // var $poster = $(this).parent();
      // ウィンドウサイズが768px以上であれば_spを_pcに置換する。
      if (windowWidth > replaceWidth) {
        $this.attr('src', $this.attr('src').replace(sp, pc));
        // $poster.attr('poster', $poster.attr('poster').replace(sp, pc));

        // ウィンドウサイズが768px未満であれば_pcを_spに置換する。
      } else {
        $this.attr('src', $this.attr('src').replace(pc, sp));
        // $poster.attr('poster', $poster.attr('poster').replace(pc, sp));
      }
      const myvideo = $(this).parent().get(0);
      myvideo.load();
    });
  }
  imageSwitch();

  // 動的なリサイズは操作後0.2秒経ってから処理を実行する。
  var winW = $(window).width();
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    winW = $(window).width();
    if (currentWidth == window.innerWidth) {
      return;
    } else {
      currentWidth = window.innerWidth;
      if (timer !== false) {
        clearInterval(timer);
      }
      timer = setTimeout(function () {
        imageSwitch();
      }, 200);
    }
  });
}

//プロジェクトプルダウン
function setProject() {
  const companyLabel = $('select[name="company"]').data('target');
  $('select[name="company"]').val(companyLabel);
  const yearLabel = $('select[name="year"]').data('target');
  $('select[name="year"]').val(yearLabel);
}

//TOP KV
function topVis() {
  gsap.registerPlugin(ScrollTrigger);
  gsap.to('#mainVis .content', {
    opacity: 0,
    scrollTrigger: {
      trigger: '.topAbout',
      start: 'top 80%',
      end: 'top 50%',
      // markers: true,
      scrub: true,
    },
  });
}

// ///////ヘッダー制御
function setHeader() {
  var timer = false;
  $(window).on('resize', function () {
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      $('header').removeClass('fixedHeader');
    }, 10);
  });

  fixedHeader();
  // console.log($('#mainVis').height())

  $(window).scroll(function () {
    fixedHeader();
  });

  function fixedHeader() {
    h = 5;
    baseHeight = h;
    if ($(this).scrollTop() <= baseHeight) {
      $('#wrapper').removeClass('fixedHeader');
    } else if ($(this).scrollTop() > baseHeight) {
      $('#wrapper').addClass('fixedHeader');
    }
  }
}

//form
function setForm() {
  $('.selectType li>span').on('click', function () {
    if (!$(this).hasClass('active')) {
      $('.selectType li>span').removeClass('active');
      $(this).addClass('active');
      var subject = $(this).find('span').text();
      $('[name=subject').val(subject);
      if ($(this).hasClass('fileUpload')) {
        $('.fileCheck .wpcf7-list-item.first label').click();
      } else {
        $('.fileCheck .wpcf7-list-item.last label').click();
      }
    }
  });
  $('.optSec').on('click', function (event) {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $('.optCtl button').addClass('dis');
    } else {
      $(this).addClass('active');
      $('.optCtl button').removeClass('dis');
    }
    event.stopPropagation();
  });

  $('.fileSet button').on('click', function (event) {
    $('input[name="file-33"]').click();
  });

  jQuery('.wpcf7-tel').attr('pattern', '\\d*');
  jQuery('.wpcf7-tel').attr(
    'onkeyup',
    'if(event.keyCode==9||event.keyCode==16) return; this.value=this.value.replace(/[^0-9]+/i,"")'
  );

  // 郵便番号、電話番号のハイフン削除
  // function insertStr (input) {
  //   return input.replace('-', '')
  // }
  //
  // $('.wpcf7-tel').on('keyup', function (e) {
  //   var input = $(this).val()
  //
  //   // 削除キーではハイフン追加処理が働かないように制御（8がBackspace、46がDelete)
  //   var key = event.keyCode || event.charCode
  //   if (key == 8 || key == 46) {
  //     return false
  //   }
  //
  //   $(this).val(insertStr(input))
  // })
  //
  // $('.wpcf7-tel').on('blur', function (e) {
  //   var input = $(this).val()
  //
  //   $(this).val(insertStr(input))
  // })
  //

  $('#confirmBtn').on('click', function () {
    $('.wpcf7c-btn-confirm').click();
  });
  $('#backBtn').on('click', function () {
    $('.wpcf7c-btn-back').click();
  });
  $('#submitBtn').on('click', function () {
    $('.wpcf7-submit').click();
  });

  // $('#press textarea').keypress(function () {
  //   $('.submitCol .sep').addClass('disp');
  // });

  // /////エラーのとき
  document.addEventListener(
    'wpcf7invalid',
    function (event) {
      setTimeout(function () {
        var position = $('.wpcf7-not-valid-tip:first').offset().top - 300;
        $('html,body').animate(
          {
            scrollTop: position,
          },
          {
            queue: false,
          }
        );
      }, 100);
    },
    false
  );
  // /////成功のとき
  document.addEventListener(
    'wpcf7mailsent',
    function (event) {
      $('html,body').animate(
        {
          scrollTop: 0,
        },
        {
          queue: false,
        }
      );
    },
    false
  );
}

$('input[name="file-33"]').change(function () {
  // 選択されたファイルがあるか確認
  if (this.files && this.files.length > 0) {
    // 最初のファイルの名前を取得
    var fileName = this.files[0].name;
    // ファイル名をコンソールに出力
    $('#mycontentFile').text(fileName);
    $('.fileSet .status').text(fileName);
  }
});
// ///////////////////////////フォーム確認画面
function setConfirm() {
  var tx = $('[name=subject').val();
  $('#subjectTx').text(tx);

  var tx = $('[name=myname]').val();
  $('#nameTx').text(tx);

  var tx = $('[name=company]').val();
  $('#companyTx').text(tx);

  var tx = $('[name=role]').val();
  $('#roleTx').text(tx);

  var tx = $('[name=myname]').val();
  $('#nameTx').text(tx);

  var tx = $('[name=myname-kana]').val();
  $('#nameTxKana').text(tx);

  var tx = $('[name=mymail]').val();
  $('#mailTx').text(tx);

  var tx = $('[name=mytel]').val();
  $('#telTx').text(tx);

  var tx = $('[name=myurl]').val();
  $('#urlTx').text(tx);

  var tx = $('[name=mycontent]').val();
  $('#mycontentTx').text(tx);

  var tx = $('[name=mycontent2]').val();
  $('#mycontentTx2').text(tx);

  // var fileInput = $('input[name="file-33"]');
  // // 選択されたファイルがあるか確認
  // if (fileInput.files && fileInput.files.length > 0) {
  //   // 最初のファイルの名前を取得
  //   var fileName = fileInput.files[0].name;
  //   console.log(fileName);
  // }
  // $('#mycontentFile').text(fileName);
  // ファイル入力フィールドの変更を監視

  var tx =
    $('[name=birth-year]').val() +
    '年 ' +
    $('[name=birth-month]').val() +
    '月' +
    $('[name=birth-date]').val() +
    '日';
  $('#birthTx').text(tx);

  var tx = $('[name=sex]').val();
  $('#sexTx').text(tx);

  var tx = $('[name=job]').val();
  $('#jobTx').text(tx);
}

//profile
function setProfile() {
  $('.articleStyle_02').on('click', function () {
    let target = '#profile_' + $(this).attr('id').replace('pr_', '');
    $(target).addClass('active');
    $('body').addClass('lockScroll');
    $('#wrapper').addClass('profileOpen');
  });
  $('#profileWrap .closeArea,#profileWrap .closeBtn,#profileWrap .col-img').on(
    'click',
    function () {
      $('#wrapper').addClass('hideEffect');
      $('body').removeClass('lockScroll');
      setTimeout(function () {
        $('#profileWrap .profileCont').removeClass('active');
        $('#wrapper').removeClass('profileOpen');
        $('#wrapper').removeClass('hideEffect');
      }, 400);
    }
  );
}

//schemeアコーディオン
function setStickyAcc() {
  var urlHash = location.hash;

  // URLにアンカーが存在する場合
  if (urlHash) {
    if ($('#wrapper').hasClass('setSp')) {
      var headerHight = $('header').height();
    } else {
      var headerHight = 0;
    }
    if (urlHash.indexOf('child') > -1) {
      var hushNav = urlHash.replace('#child_0', '');
      hushNav = '.stickyNav li:nth-child(' + hushNav + ')';
      $(hushNav).find('a').addClass('active');
      $(urlHash).find('.ttl').addClass('active');
      $(urlHash).find('.ttl').next().stop().slideDown('fast');
      $(urlHash).addClass('js-start');
      const target = $(urlHash);
      setAccWay(target);
      if (urlHash == '#child_04' || urlHash == '#child_05') {
        var videoElem;
        if ($('#wrapper').hasClass('setPc')) {
          videoElem = $(urlHash).find('.videoPc');
        } else {
          videoElem = $(urlHash).find('.videoSp');
        }
        videoElem.get(0).play();
      }
    }

    var target = $(urlHash);
    timer = setTimeout(function () {
      var position = target.offset().top - headerHight;
      $('#wrapper').addClass('active');
      $.when(
        $('html, body').animate(
          {
            scrollTop: position,
          },
          400,
          'swing'
        )
      ).done(function () {
        var diff = target.offset().top - headerHight;
        if (diff === position) {
        } else {
          $('html, body').animate(
            {
              scrollTop: diff,
            },
            400,
            'swing'
          );
        }
      });
    }, 500);
  } else {
    $('#wrapper').addClass('active');
  }

  $('.stickyAccordion >.item >.inner>.ttl').on('click', function () {
    var index = $(this).parents('.item').index('.stickyAccordion .item') + 1;
    var targetNav = '.stickyNav li:nth-child(' + index + ')';
    // targetNav = $(targetNav);
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $(this).next().slideUp('fast');
      $(targetNav).find('a').removeClass('active');
      $(this).parents('.item').removeClass('js-start');
    } else {
      if ($('#wrapper').hasClass('setPc')) {
        var headerHeight = 0;
      } else {
        var headerHeight = 100;
      }
      $('.stickyNav a').removeClass('active');
      $(targetNav).find('a').addClass('active');
      $('.stickyAccordion >.item >.inner>.ttl').removeClass('active');
      $('.stickyAccordion >.item >.inner>.content').hide();
      var position = $(this).offset().top - headerHeight;
      $(this).addClass('active');
      $(this).parents('.item').addClass('js-start');
      setWay();
      const target = $(this).parents('.item');
      setAccWay(target);
      $(this).next().stop().slideDown();
      if (
        $(this).parents('.item').attr('id') == 'child_04' ||
        $(this).parents('.item').attr('id') == 'child_05'
      ) {
        var videoElem;
        if ($('#wrapper').hasClass('setPc')) {
          videoElem = $(this).parents('.item').find('.videoPc');
        } else {
          videoElem = $(this).parents('.item').find('.videoSp');
        }
        videoElem.get(0).play();
      }
      $('html, body').animate(
        {
          scrollTop: position,
        },
        400,
        'swing'
      );
    }
  });
  $('.stickyNav a').on('click', function () {
    $('.stickyAccordion >.item >.inner>.ttl').removeClass('active');
    $('.stickyAccordion >.item >.inner>.content').hide();
    $('.stickyNav a').removeClass('active');
    $(this).addClass('active');
    var target = $(this).attr('href');
    target = $(target);
    if (!target.find('.ttl').hasClass('active')) {
      target.find('.ttl').addClass('active');
      target.find('.ttl').next().stop().slideDown();
      target.addClass('js-start');
      if ($(this).attr('href') == '#child_04' || $(this).attr('href') == '#child_05') {
        var videoElem;
        if ($('#wrapper').hasClass('setPc')) {
          videoElem = target.find('.videoPc');
        } else {
          videoElem = target.find('.videoSp');
        }
        videoElem.get(0).play();
      }
      setAccWay(target);
      setWay();
    }
  });
  $('.nav-scheme a').on('click', function () {
    if ($('#wrapper').hasClass('scheme')) {
      $('.stickyAccordion >.item >.inner>.ttl').removeClass('active');
      $('.stickyAccordion >.item >.inner>.content').hide();
      $('.stickyNav a').removeClass('active');
      var index = $(this).parent().index() + 1;
      var targetNav = '.stickyNav li:nth-child(' + index + ')';
      $(targetNav).find('a').addClass('active');
      var target = $(this).attr('href');
      target = $(target);
      if (!target.find('.ttl').hasClass('active')) {
        target.find('.ttl').addClass('active');
        target.find('.ttl').next().stop().slideDown();
        target.addClass('js-start');
        if ($(this).attr('href') == '#child_04' || $(this).attr('href') == '#child_05') {
          var videoElem;
          if ($('#wrapper').hasClass('setPc')) {
            videoElem = target.find('.videoPc');
          } else {
            videoElem = target.find('.videoSp');
          }
          videoElem.get(0).play();
        }
        setAccWay(target);
        setWay();
      }
    }
  });
}

// Rellax
function setRellax() {
  var rellax = new Rellax('.js-rellax');
  // var rellax = new Rellax('.js-rellax', {
  //   speed: -2,
  //   center: false,
  //   wrapper: null,
  //   round: true,
  //   vertical: true,
  //   horizontal: false
  // })
}

//フィロソフィー
function setPhilosophy() {
  // 固定する要素を取得する
  var fixedElement = $('.fvSec .bgImg');

  // スクロールイベントを監視する
  $(window).scroll(function () {
    if ($('#wrapper').hasClass('setPc')) {
      if ($('#wrapper').hasClass('pickUp')) {
        var scrollTop = $(window).scrollTop() - 40;
      } else {
        var scrollTop = $(window).scrollTop();
      }

      fixedElement.css({
        top: scrollTop,
      });
    }
  });
}

// //リクルート
// function setRecruitVis() {
//   // 固定する要素を取得する
//   var fixedElement = $('.recruitVis .bgImg');

//   // スクロールイベントを監視する
//   $(window).scroll(function () {
//     if ($('#wrapper').hasClass('setPc')) {
//       if ($('#wrapper').hasClass('pickUp')) {
//         var scrollTop = $(window).scrollTop() - 40;
//       } else {
//         var scrollTop = $(window).scrollTop();
//       }

//       fixedElement.css({
//         top: scrollTop,
//       });
//     }
//   });
// }

// //////////////////////////メインメニュー
var current_scrollY;
function setMainMenu() {
  $('#menuBtn').on('click', function () {
    if (!$('#menuBtn').hasClass('active')) {
      openFnc();
    } else {
      closeFnc();
    }
  });
  // $('#mainNav a').on('click', function (event) {
  //   event.stopPropagation()
  // })
  //
  $('#clickBlocker').on('click', function () {
    closeFnc();
  });

  var winW = $(window).width();
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    winW = $(window).width();
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearInterval(timer);
    }
    timer = setTimeout(function () {
      if (winW > tabletNum) {
        closeFnc();
      }
    }, 200);
  });
}
function openFnc() {
  current_scrollY = $(window).scrollTop();
  $('#menuBtn').addClass('active');
  $('#wrapper').addClass('menuOpen');
  $('body').addClass('lockScroll');
  // $('#outerMenu').css('top', -current_scrollY);
  // 検索補助
  // $('header .btnSubmit').removeClass('search-url')
  // $('#menuPanel .btnSubmit').addClass('search-url')
  // setTimeout(function () {
  //   $('html, body').prop({
  //     scrollTop: 0,
  //   });
  // }, 100);
}

function closeFnc() {
  $('#menuBtn').removeClass('active');
  $('#outerMenu').css('top', '');
  $('#wrapper').removeClass('menuOpen');
  $('body').removeClass('lockScroll');
  // 検索補助
  // $('header .btnSubmit').addClass('search-url')
  // $('#menuPanel .btnSubmit').removeClass('search-url')
  // $('html, body').prop({
  //   scrollTop: current_scrollY,
  // });
}

// ///////TOPボタン
function setScrollTop() {
  if ($('#wrapper').hasClass('setVis')) {
    var baseHeight = $('.fv').height();
  } else {
    var baseHeight = 10;
  }
  var footH = $('footer').height();
  fixedToTop();

  $(window).scroll(function () {
    fixedToTop();
  });

  function fixedToTop() {
    var scrollHeight = $(document).height() - footH;
    if ($(this).scrollTop() <= baseHeight) {
      $('#scrollTop').removeClass('active');
    } else if ($(this).scrollTop() > baseHeight) {
      $('#scrollTop').addClass('active');
    }
    if ($(window).height() + $(this).scrollTop() >= scrollHeight) {
      $('#scrollTop').addClass('footPos');
    } else {
      $('#scrollTop').removeClass('footPos');
    }
  }
}

//GSAP
function setGsap() {
  gsap.registerPlugin(ScrollTrigger);
  document.querySelectorAll('.js-way,.way,.sp-way').forEach((el, index) => {
    ScrollTrigger.create({
      trigger: el,
      id: index + 1,
      start: 'top 80%',
      toggleClass: { targets: el, className: 'is-active' },
      once: true,
      // markers: true,
    });
  });
}

//グローバルメニューアコーディオン
function setAccMenu() {
  if ($('#wrapper').hasClass('about')) {
    $('.nav-about').find('.parentNav').addClass('active');
    $('.nav-about').find('.child').slideDown('fast');
    ///
    $('.nav-about .parentNav').on('click', function (event) {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).next().slideUp('fast');
      } else {
        $('.globalNav .parentNav').removeClass('active');
        $('.globalNav .child').slideUp('fast');
        $(this).addClass('active');
        $(this).next().slideDown('fast');
      }
      event.stopPropagation();
    });
  } else if ($('#wrapper').hasClass('scheme')) {
    $('.nav-scheme').find('.parentNav').addClass('active');
    $('.nav-scheme').find('.child').slideDown('fast');
    ///
    $('.nav-scheme .parentNav').on('click', function (event) {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).next().slideUp('fast');
      } else {
        $('.globalNav .parentNav').removeClass('active');
        $('.globalNav .child').slideUp('fast');
        $(this).addClass('active');
        $(this).next().slideDown('fast');
      }
      event.stopPropagation();
    });
  } else if ($('#wrapper').hasClass('philosophy')) {
    $('.nav-philosophy').find('.parentNav').addClass('active');
    $('.nav-philosophy').find('.child').slideDown('fast');
    ///
    $('.nav-philosophy .parentNav').on('click', function (event) {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).next().slideUp('fast');
      } else {
        $('.globalNav .parentNav').removeClass('active');
        $('.globalNav .child').slideUp('fast');
        $(this).addClass('active');
        $(this).next().slideDown('fast');
      }
      event.stopPropagation();
    });
  } else if (
    $('#wrapper').hasClass('contact') ||
    $('#wrapper').hasClass('faq') ||
    $('body').hasClass('page-template-page-complete') ||
    $('body').hasClass('page-template-page-privacy-policy')
  ) {
    $('.nav-contact').find('.parentNav').addClass('active');
    $('.nav-contact').find('.child').slideDown('fast');
    ///
    $('.nav-contact .parentNav').on('click', function (event) {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).next().slideUp('fast');
      } else {
        $('.globalNav .parentNav').removeClass('active');
        $('.globalNav .child').slideUp('fast');
        $(this).addClass('active');
        $(this).next().slideDown('fast');
      }
      event.stopPropagation();
    });
  }
  $('.globalNav .parentNav .icon').on('click', function (event) {
    if ($(this).parents('.parentNav').hasClass('active')) {
      $(this).parents('.parentNav').removeClass('active');
      $(this).parents('.parentNav').next().slideUp('fast');
    } else {
      $('.globalNav .parentNav').removeClass('active');
      $('.globalNav .child').slideUp('fast');
      $(this).parents('.parentNav').addClass('active');
      $(this).parents('.parentNav').next().slideDown('fast');
    }
    event.stopPropagation();
  });
}

// テキストアニメーション用span生成
function setSpan() {
  $('.txEffect>span').each(function () {
    var text = $.trim(this.textContent),
      html = '';

    text.split('').forEach(function (v) {
      html += '<span>' + v + '</span>';
    });

    this.innerHTML = html;
  });
}

// ///////waypoint
function setWay() {
  $('.way,.way-slow,.alphaWay,.js-way,.postContent>*,.js-start .lineway').waypoint(
    function (direction) {
      var activePoint = $(this.element);
      if (direction === 'down') {
        // scroll down
        activePoint.addClass('is-active');
        timer = setTimeout(function () {
          activePoint.addClass('is-active-after');
        }, 500);
      }
    },
    {
      offset: '70%',
    }
  );
}

function setAccWay(target) {
  timer = setTimeout(function () {
    target.find('.accway').waypoint(
      function (direction) {
        var activePoint = $(this.element);
        if (direction === 'down') {
          // scroll down
          activePoint.addClass('is-active');
          timer = setTimeout(function () {
            activePoint.addClass('is-active-after');
          }, 500);
        }
      },
      {
        offset: '70%',
      }
    );
  }, 500);
}

// ////////////////////////////アコーディオン
function setAcc() {
  $('.accSec .ttl').on('click', function () {
    $(this).toggleClass('active');
    $(this).next().stop().slideToggle('fast');
  });
  $('.careerItem .head').on('click', function () {
    $(this).parents('.item').toggleClass('active');
    $(this).next().stop().slideToggle();
  });
  $('.accessAcc .ttl').on('click', function () {
    $(this).parent().toggleClass('active');
    $(this).next().stop().slideToggle('fast');
  });
}

// //////////////////////////////ロード完了
function setLoaded() {
  $('#wrapper').addClass('loaded');
  loadStart();
  // if ($('#wrapper').hasClass('home')) {
  //   loadStart()
  // }else {
  //   $('#wrapper').addClass('loadedDone')
  //   $('#wrapper').addClass('loadEnd')
  // }
}

function loadStart() {
  timer = setTimeout(function () {
    $('#wrapper').addClass('loadedDone');
  }, 200);
  timer = setTimeout(function () {
    $('#wrapper').addClass('loadEnd');
  }, 1500);
  timer = setTimeout(function () {
    $('#wrapper').addClass('homeStart');
  }, 1200);
  // $('body,html').animate({
  //   scrollTop: 0
  // }, 0, 'swing')
}

// function setGnav () {
//   var i = 0
//   setInterval(function () {
//     $('#headNav li').eq(i).addClass('start')
//     i++
//     if (i >= $('#headNav li').length) i = 0
//   }, 100)
// }

// ////////////ウィンドウサイズを判別
function judgeWinSize() {
  var winW = $(window).width();
  if (winW > breakNum) {
    $('#wrapper').addClass('setPc');
  } else {
    $('#wrapper').addClass('setSp');
  }

  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      winW = $(window).width();
      if (winW > breakNum) {
        $('#wrapper').addClass('setPc');
        $('#wrapper').removeClass('setSp');
      } else {
        $('#wrapper').addClass('setSp');
        $('#wrapper').removeClass('setPc');
      }
    }, 200);
  });
}

// /////////////////////////////スムーススクロール
function setScroll() {
  // var headerHight = $('header').height() + 40
  // var headerHight = $('header').height()
  if ($('#wrapper').hasClass('setPc')) {
    var headerHeight = 0;
  } else {
    var headerHeight = 100;
  }
  $('a[href^="#"]').click(function (e) {
    var href = $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'html' : href);
    // var position = target.offset().top;

    if ($(this).hasClass('unqNav')) {
      closeFnc();
    }
    setTimeout(function () {
      var position = target.offset().top - headerHeight;
      $('html, body').animate(
        {
          scrollTop: position,
        },
        400,
        'swing'
      );
      if (href == '#contChild') {
        $('.accessAcc').addClass('active');
        $('.accessAccCont').slideDown('fast');
      }
    }, 100);
    e.preventDefault();
    // $.when(
    //   $('html, body').animate(
    //     {
    //       scrollTop: position,
    //     },
    //     400,
    //     'swing'
    //   ),
    //   e.preventDefault()
    // ).done(function () {
    //   var diff = target.offset().top;
    //   if (diff === position) {
    //   } else {
    //     $('html, body').animate(
    //       {
    //         scrollTop: diff,
    //       },
    //       400,
    //       'swing'
    //     );
    //   }
    // });
  });
}

function startScroll() {
  // var headerHight = 20
  if ($('#wrapper').hasClass('setSp')) {
    var headerHight = $('header').height();
  } else {
    var headerHight = 0;
  }
  var href = $(location).attr('hash');
  if (href) {
    timer = setTimeout(function () {
      var target = $(href == '#' || href == '' ? 'html' : href);
      var position = target.offset().top - headerHight;
      $.when(
        $('html, body').animate(
          {
            scrollTop: position,
          },
          400,
          'swing'
        )
      ).done(function () {
        var diff = target.offset().top - headerHight;
        if (diff === position) {
        } else {
          $('html, body').animate(
            {
              scrollTop: diff,
            },
            10,
            'swing'
          );
        }
      });
      if (href == '#contChild') {
        $('.accessAcc').addClass('active');
        $('.accessAccCont').slideDown('fast');
      }
    }, 500);
  }
}

// ////////////////////////////////////ランドスケープ判定
var isLandscape = function () {
  if (window.innerHeight > window.innerWidth) {
    jQuery('body').addClass('portrait');
    jQuery('body').removeClass('landscape');
  } else {
    jQuery('body').addClass('landscape');
    jQuery('body').removeClass('portrait');
  }
};

if (_ua.Mobile) {
  jQuery(window).resize(function () {
    isLandscape();
  });
  isLandscape();
}

// //////////////////////////////高さ揃え
function heightLineGroup() {
  // setAutoHeight('#photoDiary .articleStyle_02 .inner')
  var winW = $(window).width();
  if (winW > breakNum) {
    // setAutoHeight('.setH_01 h2', 4)
    // setAutoHeight('.setH_01 h2')
    // setAutoHeight('#photoDiary .articleStyle_02 .inner')
    // setAutoHeight(".setH_01 .summary",3)
  } else {
    setAutoHeight('.setH_01 h2', 2);
    setAutoHeight('.setH_02 h2', 2);
    // setAutoHeight("#setH_08 h2",2)
  }

  startResize();
}

function setAutoHeight(target, count) {
  $(target).tile(count);
}

function startResize() {
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      heightLineGroup();
    }, 200);
  });
}
